import { Injectable } from '@angular/core';
import { isDevMode } from '@angular/core';

@Injectable()
export class GlobalConstants {
    readonly APIURL: string;
    readonly START_YEAR: number = 2016;
    isLocal: boolean;

    constructor() {
        if (this.getMode() !== true) {
            console.log("production");
            this.APIURL = 'http://198.57.229.200/api';
        }
        else {
            console.log("development");
            //this.APIURL = 'http://localhost:8000/api';
            this.APIURL = 'http://198.57.229.200/api';
        }
    }

    private getMode() {
        this.isLocal = isDevMode();
        console.log("constants mode isLocal", this.isLocal);
        return this.isLocal;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/_constants/global.constants.ts